// Dependencies
import React from 'react';
import { ThemeContext } from '../../../../components/theme/Theme.jsx';
import radium from 'radium';
import { connect } from 'react-redux';


// Styles
import './TicketsOverview.scss';

function TicketsOverview(props) {
	const context = React.useContext(ThemeContext);
	const style = {
		categoryPricelevelContainer: {
			lineHeight: context.themeManager
				.value('tickets-overview', 'lineHeight', 'line-height-300'),
		},
		categoryContainer: {
			display: 'flex',
			lineHeight: 'inherit',
			margin: '0 0 .1em',
		},
		price: {
			lineHeight: context.themeManager
				.value('tickets-overview', 'priceLineHeight', 'line-height-300'),
		},
		pricelevelName: {
			fontSize: context.themeManager.value('tickets-overview', 'priceLevelFontSize', 'font-size-90'),
		},
		ticketPrice: {
			fontWeight: 400,
			fontSize: context.themeManager.value('tickets-overview', 'ticketPriceFontSize', 'font-size-80'),
		},
		seatInfo: {
			fontSize: context.themeManager.value('tickets-overview', 'seatInfoFontSize', 'font-size-90'),
			fontWeight: 400,
		},
	};

	const sortedTickets = Object.assign([], props.tickets).sort((a, b) => (a.categoryType > b.categoryType ? 1 : -1));

	return (
		<div>
			{sortedTickets.map((ticketGroup, index) => (
				<div key={index.toString()}>
					<div className="tickets-overview__container">
						<div style={style.categoryPricelevelContainer} className="tickets-overview__category-price-container">
							<div style={style.categoryContainer} className="tickets-overview__category-container">
								<div className="category__amount">
									{ticketGroup.numberOfSeats}
								</div>
								<div>x</div>
								<div className="category__name">
									{ticketGroup.category}
								</div>
							</div>
							<div style={style.pricelevelName} className="price-level__name">
								{ticketGroup.priceLevel}
							</div>
							<div style={style.seatInfo}>
								{ ticketGroup.block &&
									<span className="seat-info__element">Block {ticketGroup.block}</span>
								}
								{ ticketGroup.rowNumber &&
									<span className="seat-info__element">Reihe {ticketGroup.rowNumber}</span>
								}
								{ ticketGroup.seatNumber &&
									<span className="seat-info__element">Sitz {ticketGroup.seatNumber}</span>
								}
								{ ((ticketGroup.isVisualBulkTicket || (!ticketGroup.isVisualBulkTicket && !ticketGroup.isVisualTicket))
								&& props.showFreeSeatingTxt) &&
									<span className="seat-info__element">Freie Platzwahl</span>
								}
							</div>
						</div>
						<div style={style.price} className="price__container">
							<div className="category__total">
								{parseFloat(ticketGroup.subTotal.money.value).toFixed(2)} €
							</div>
							{ (ticketGroup.numberOfSeats > 1) &&
								<div style={style.ticketPrice}>(je {parseFloat(ticketGroup.pricePerSeat.money.value).toFixed(2)} €)</div>
							}
						</div>
					</div>
				</div>
			))}
		</div>
	);
}

// ------------------------------
// Store Connection
// ------------------------------
const mapStateToProps = (state) => {
	const merchantId = state.merchant.merchantId;

	return {
		showFreeSeatingTxt: (merchantId !== 'sdf'),
	};
};

export default connect(mapStateToProps)(radium(TicketsOverview));
